// Daten (mit kurzen, passenden Beschreibungen)
const imageRecommendations = [
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/mehnersmoos.jpg?v=1736508340", description: "Um 3 Uhr Nachts, hab ich am meisten Bock auf das Filow Kissen." },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/chapo.jpg?v=1736508340", description: "Ich hab Song 'Schöne Dinge' nur über dieses Kissen geschrieben" },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Ikkimel.jpg?v=1736509929", description: "Das einzig männliche, dass es auch im Bett bringt ihr kleinen F*tzen" },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Ski_Aggu.jpg?v=1736508340", description: "Manchmal bin ich 3 Tage wach. Da brauch man einfach ein guten Schlaf. Warte das hat sich gereimt, Moritz mach das Mic an" },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Ritter_Lean.jpg?v=1736508340", description: "Das Kissen ist unnormal Links, Feministisch, Woke und Ally" },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/World_Wide_Wohnzimmer.jpg?v=1736508340", description: "Wir haben das Kissen zu einer absoluten Legende gemacht und verdienen trotzdem keinen Cent daran" },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Gronkh.jpg?v=1736508340", description: "Hach ja… das Filow Kissen. Ich weiß noch als ich die erste Minecraft Folge aufgenommen habe saß ich da schon drauf. Gebt eure Kohle Kohle Kohle aus. Jetzt." },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Zarbex.jpg?v=1736508340", description: "Ich sag euch ehrlich Diggi, das ist einfach gemütlich Diggi und schlicht und ähh jaa Diggi einfach kein Schnickschack. Gönn dir." },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Sev.jpg?v=1736508340", description: "Das gruseligste was ich besitze." },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Ollimeee.jpg?v=1736508340", description: "Ich hab das damals au der WG geklaut und Felix checkt es noch immer nicht" },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Henke.jpg?v=1736508340", description: "Ich habe zum 8. mal aufgehört zu rauchen, dafür hat das Filow Kissen wegen mir angefangen" },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Nico_Santos.jpg?v=1764003698", description: "Hey, ich bin Nico Santos" },
  { image: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Money_Boy.jpg?v=1764003696", description: "Burr" }
];


const productLink = "https://filow.shop/products/filow-pillow-kissen";

// Mapping Produkt -> GIF
const productGifConfig = [
  {
    url: "products/filow-pillow-kissen",
    gif: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Shop_Addon_Kissen_360p_quadrat.gif?v=1763998160"
  },
  {
    url: "products/hoodie-strass",
    gif: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Shop_Addon_Pullover_360p_quadrat_1.gif?v=1763998888"
  },
  {
    url: "products/filow-nfc-cd-schlusselanhanger",
    gif: "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/Shop_Addon_Anhaenger_360p_quadrat.gif?v=1763999137"
  }
];

console.log("[custom.js] productGifConfig:", productGifConfig);

// Name aus Dateiname ableiten
function getNameFromUrl(url) {
  try {
    const file = url.split("/").pop().split("?")[0]; // zB "Ritter_Lean.jpg"
    const base = file.replace(/\.[a-z0-9]+$/i, "");   // "Ritter_Lean"
    return base.replace(/[_-]+/g, " ");               // "Ritter Lean"
  } catch {
    return "";
  }
}

// DOM-Refs Slider
const container = document.getElementById("empfohlenvon");
if (!container) {
  console.log("[custom.js] #empfohlenvon not found");
}
const imgWrap = container ? container.querySelector(".empfohlenvon-image") : null;
const quoteEl = container ? container.querySelector(".empfohlenvon-quote") : null;

// Slider nur initialisieren, wenn Container existiert
if (container && imgWrap && quoteEl) {
  console.log("[custom.js] Initializing empfohlen Slider");

  const imgEl = document.createElement("img");
  imgEl.alt = "Empfohlen von";
  imgEl.style.width = "100%";
  imgEl.style.height = "100%";
  imgEl.style.borderRadius = "10px";
  imgEl.style.objectFit = "cover";
  imgEl.style.display = "block";
  imgEl.style.opacity = "1";
  imgEl.style.transition = "opacity .35s ease";

  // Bild klickbar machen, falls productLink gesetzt ist
  if (productLink) {
    const linkEl = document.createElement("a");
    linkEl.href = productLink;
    linkEl.className = "empfohlenvon-link";
    linkEl.appendChild(imgEl);
    imgWrap.appendChild(linkEl);
  } else {
    imgWrap.appendChild(imgEl);
  }

  quoteEl.style.opacity = "1";
  quoteEl.style.transition = "opacity .35s ease";
  quoteEl.style.overflow = "hidden"; // gegen Springen
  let idx = 0;

  function setMaxQuoteHeight() {
    const saved = quoteEl.innerHTML;
    let max = 0;
    imageRecommendations.forEach(it => {
      const name = getNameFromUrl(it.image);
      quoteEl.innerHTML = `${it.description}<br/><b>- ${name}</b>`;
      const h = quoteEl.scrollHeight;
      if (h > max) max = h;
    });
    quoteEl.style.height = max + "px";
    quoteEl.innerHTML = saved;
  }

  function render(i, instant = false) {
    const it = imageRecommendations[i];
    const name = getNameFromUrl(it.image);

    if (instant) {
      imgEl.src = it.image;
      quoteEl.innerHTML = `${it.description}<br/><b>- ${name}</b>`;
      imgEl.style.opacity = "1";
      quoteEl.style.opacity = "1";
      return;
    }

    imgEl.style.opacity = "0";
    quoteEl.style.opacity = "0";

    setTimeout(() => {
      imgEl.src = it.image;
      quoteEl.innerHTML = `${it.description}<br/><b>- ${name}</b>`;
      void imgEl.offsetWidth;
      imgEl.style.opacity = "1";
      quoteEl.style.opacity = "1";
    }, 350);
  }

  setMaxQuoteHeight();
  render(idx, true);

  setInterval(() => {
    idx = (idx + 1) % imageRecommendations.length;
    render(idx, false);
  }, 6000);

  window.addEventListener("load", setMaxQuoteHeight);
  window.addEventListener("resize", setMaxQuoteHeight);
} else {
  console.log("[custom.js] Slider not initialized, missing elements");
}

// Liste unter #kissen-empfohlen aufbauen
(function buildKissenList() {
  const listContainer = document.getElementById("kissen-empfohlen");
  if (!listContainer) {
    console.log("[custom.js] #kissen-empfohlen not found");
    return;
  }
  console.log("[custom.js] Building kissen list");

  listContainer.innerHTML = '';
  const h1 = document.getElementsByTagName("h1")[0];
  if (h1) h1.remove();

  listContainer.classList.add("kissen-list");
  
  imageRecommendations.forEach((it, i) => {
    const name = getNameFromUrl(it.image);

    const item = document.createElement("div");
    item.className = "kissen-item";
    if (i % 2 === 1) {
      item.classList.add("reverse");
    }

    const imageCol = document.createElement("div");
    imageCol.className = "kissen-image";

    const img = document.createElement("img");
    img.src = it.image + "&width=150";
    img.alt = name ? `Filow Kissen Empfehlung von ${name}` : "Filow Kissen Empfehlung";
    img.loading = "lazy";
    img.decoding = "async";

    // Bild klickbar machen, falls productLink gesetzt ist
    if (productLink) {
      const linkEl = document.createElement("a");
      linkEl.href = productLink;
      linkEl.className = "kissen-image-link";
      linkEl.appendChild(img);
      imageCol.appendChild(linkEl);
    } else {
      imageCol.appendChild(img);
    }

    const textCol = document.createElement("div");
    textCol.className = "kissen-text";

    const p = document.createElement("p");
    p.textContent = it.description;

    const nameEl = document.createElement("div");
    nameEl.className = "kissen-name";
    nameEl.textContent = name ? `- ${name}` : "";

    textCol.appendChild(p);
    textCol.appendChild(nameEl);

    item.appendChild(imageCol);
    item.appendChild(textCol);

    listContainer.appendChild(item);
  });
})();

// Featured Collection GIF Hover: srcset und sizes entfernen und wiederherstellen
(function initFeaturedCollectionGifHover() {
  const sections = document.querySelectorAll('[data-section-type="featured-collection"]');
  console.log("[custom.js] Featured collection sections found:", sections.length);
  if (!sections.length) return;

  sections.forEach((section, sectionIndex) => {
    const links = section.querySelectorAll('a[href*="/products/"]');
    console.log("[custom.js] Section", sectionIndex, "product links found:", links.length);
    if (!links.length) return;

    links.forEach(link => {
      const href = link.getAttribute("href") || "";
      const idx = href.indexOf("products/");
      if (idx === -1) {
        console.log("[custom.js] Link without products/ href:", href);
        return;
      }

      const relUrl = href.slice(idx); // zB "products/filow-pillow-kissen"
      const cfg = productGifConfig.find(c => relUrl.startsWith(c.url));
      console.log("[custom.js] Checking gif config for relUrl:", relUrl, "found:", cfg ? cfg.gif : "none");

      if (!cfg || !cfg.gif) return;

      const card = link.closest(".card, .product-card, .grid__item, .product-item") || link.parentElement;
      if (!card) {
        console.log("[custom.js] No card container found for link", href);
        return;
      }

      const img = card.querySelector(".media img");
      if (!img) {
        console.log("[custom.js] No .media img found inside card for", href);
        return;
      }

      console.log("[custom.js] Hooking hover GIF for", relUrl, "original src:", img.getAttribute("src"));

      const originalSrc = img.getAttribute("src");
      const originalSrcset = img.getAttribute("srcset");
      const originalSizes = img.getAttribute("sizes");

      card.addEventListener("mouseenter", () => {
        console.log("[custom.js] hover in set GIF for", relUrl, "gif:", cfg.gif);
        img.setAttribute("src", cfg.gif);
        img.removeAttribute("srcset");
        img.removeAttribute("sizes");
      });

      card.addEventListener("mouseleave", () => {
        console.log("[custom.js] hover out restore image for", relUrl);
        if (originalSrc) img.setAttribute("src", originalSrc);
        if (originalSrcset) img.setAttribute("srcset", originalSrcset);
        else img.removeAttribute("srcset");
        if (originalSizes) img.setAttribute("sizes", originalSizes);
        else img.removeAttribute("sizes");
      });
    });
  });
})();

// Produktseite: erstes Featured Bild und zugehorige zoomImg durch GIF ersetzen
(function initProductPageFeaturedGif() {
  function applyProductGifToProductPage() {
    if (!document.body) return;

    const path = window.location.pathname || "";
    const isProductTemplate = document.body.classList.contains("template-product");
    console.log("[custom.js] Product page check body template-product:", isProductTemplate, "path:", path);

    if (!isProductTemplate && !path.includes("/products/")) {
      console.log("[custom.js] Not a product page, abort featured gif replacement");
      return;
    }

    const idx = path.indexOf("products/");
    if (idx === -1) {
      console.log("[custom.js] No products/ in path, abort");
      return;
    }

    const relUrl = path.slice(idx).replace(/\/+$/, ""); // "products/handle"
    const cfg = productGifConfig.find(c => relUrl.startsWith(c.url));
    console.log("[custom.js] Product page relUrl:", relUrl, "gif config:", cfg ? cfg.gif : "none");

    if (!cfg || !cfg.gif) {
      console.log("[custom.js] No GIF config for this product page");
      return;
    }

    const selectors = [
      ".product-images img.product-featured-media",
      ".product-images .product-single__media img",
      ".product-images img"
    ];

    let img = null;
    for (const sel of selectors) {
      const all = document.querySelectorAll(sel);
      console.log("[custom.js] Checking selector", sel, "found count:", all.length);
      if (all.length > 0) {
        img = all[0];
        break;
      }
    }

    if (!img) {
      console.log("[custom.js] No product featured image found for GIF replacement");
      return;
    }

    console.log(
      "[custom.js] Replacing first product image with GIF",
      cfg.gif,
      "original src:",
      img.getAttribute("src")
    );

    img.setAttribute("src", cfg.gif);
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");

    // zoomImg im gleichen Container ebenfalls updaten
    const wrapper = img.closest(".productimage") || img.closest(".media-image-wrap") || img.parentElement;
    let zoomImg = null;
    if (wrapper) {
      zoomImg = wrapper.querySelector("img.zoomImg");
    }
    if (!zoomImg) {
      zoomImg = document.querySelector("img.zoomImg");
    }

    if (zoomImg) {
      console.log(
        "[custom.js] Updating zoomImg src to GIF",
        cfg.gif,
        "previous src:",
        zoomImg.getAttribute("src")
      );
      zoomImg.setAttribute("src", cfg.gif);
    } else {
      console.log("[custom.js] No zoomImg found to update");
    }
  }

  if (document.readyState === "loading") {
    console.log("[custom.js] DOM not ready yet, waiting for DOMContentLoaded for product GIF");
    document.addEventListener("DOMContentLoaded", applyProductGifToProductPage);
  } else {
    console.log("[custom.js] DOM already ready, applying product GIF now");
    applyProductGifToProductPage();
  }
})();

(() => {

  document.getElementById("close-newsletter")?.addEventListener("click", e => {
    e.currentTarget.remove();
    document.getElementById("subscribeform").style.transform = "rotate(3deg)";
  });

  const container = document.getElementById("scrolling-clouds");
  if (!container) {
    console.log("[custom.js] #scrolling-clouds not found");
    return;
  }

  console.log("[custom.js] Initializing scrolling clouds");

  const CLOUD_URLS = [
    "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/wolke5.png?v=1760529501",
    "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/wolke6.png?v=1760529501",
    "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/wolke7.png?v=1760529501",
    "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/wolke8.png?v=1760529501",
    "https://cdn.shopify.com/s/files/1/0890/0064/0853/files/wolke9.png?v=1760529501"
  ];
  const styleTag = document.createElement("style");
  styleTag.textContent = `
    #scrolling-clouds { position: absolute; left: 0; top: 50px; width: 100%; height: 200px; overflow: hidden; pointer-events: none; z-index: -5; }
    #scrolling-clouds .mover { position: absolute; left: 0; top: 0; will-change: transform; }
    #scrolling-clouds .sprite { position: relative; }
    #scrolling-clouds .sprite img { height: 60px; width: auto; display: block; }
    @keyframes cloudMove {
      0%   { transform: translateX(100vw); }
      100% { transform: translateX(-200px); }
    }
  `;
  document.head.appendChild(styleTag);

  const PER_PIXEL = 200;
  const MIN_SCALE = 0.6;
  const MAX_SCALE = 1.3;
  const MIN_SEC = 100;
  const MAX_SEC = 360;
  const BASE_OPACITY = 0.6;
  const OPACITY_JITTER = 0.35;

  let desiredCount = 0;
  let clouds = [];

  const rand = (min, max) => Math.random() * (max - min) + min;
  const pick = arr => arr[Math.floor(Math.random() * arr.length)];

  function makeCloud(index, total) {
    const mover = document.createElement("div");
    mover.className = "mover";

    const sprite = document.createElement("div");
    sprite.className = "sprite";

    const img = document.createElement("img");
    img.decoding = "async";
    img.loading = "lazy";
    img.src = pick(CLOUD_URLS);

    sprite.appendChild(img);
    mover.appendChild(sprite);
    container.appendChild(mover);

    function randomize(startFresh = false, presetDelay = null) {
      if (!startFresh && Math.random() < 0.5) img.src = pick(CLOUD_URLS);

      const scale = rand(MIN_SCALE, MAX_SCALE);
      const flip = Math.random() < 0.5 ? -1 : 1;
      const opacity = Math.min(1, Math.max(0.2, BASE_OPACITY + (Math.random() - 0.5) * 2 * OPACITY_JITTER));

      sprite.style.transform = `scale(${scale}) scaleX(${flip})`;
      img.style.opacity = opacity.toFixed(2);

      const imgHeight = 60 * scale;
      const maxTop = Math.max(0, container.clientHeight - imgHeight);
      mover.style.top = `${rand(0, maxTop)}px`;

      const duration = rand(MIN_SEC, MAX_SEC).toFixed(2);
      const evenDelay = -(duration / total) * index + Math.random() * 10 - Math.random() * 10;
      const finalDelay = presetDelay !== null ? presetDelay : evenDelay;

      mover.style.animation = `cloudMove ${duration}s linear infinite`;
      mover.style.animationDelay = `${finalDelay}s`;
    }

    mover.addEventListener("animationiteration", () => {
      mover.style.animationName = "none";
      mover.offsetWidth;
      randomize(true, 0);
    });

    randomize(false);
    return { mover, sprite, img, randomize };
  }

  function mountDesiredCount() {
    const width = window.innerWidth || document.documentElement.clientWidth || 1200;
    desiredCount = Math.max(1, Math.ceil(width / PER_PIXEL));
    console.log("[custom.js] Clouds desired count:", desiredCount);

    clouds.forEach(c => c.mover.remove());
    clouds = [];
    for (let i = 0; i < desiredCount; i++) {
      clouds.push(makeCloud(i, desiredCount));
    }
  }

  mountDesiredCount();

  let resizeTO = null;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTO);
    resizeTO = setTimeout(mountDesiredCount, 200);
  });
})();
